module.exports = __webpack_public_path__ + "img/ihumane-green-long.7c21e9a3.svg";